import React, { MouseEventHandler } from 'react';

import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import { Switch, Button } from '@mui/material';
import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './NotificationsSettingsItem.module.scss';

type NotificationsSettingsItemProps = {
  title: string;
  description: string;
  checked: boolean;
  onChange?: (checked: boolean) => void;
  switchDisabled?: boolean;
  extraActionTitle?: string;
  onExtraAction?: MouseEventHandler<HTMLButtonElement>;
};

const NotificationsSettingsItem = ({
  title,
  description,
  checked,
  onChange,
  switchDisabled,
  extraActionTitle,
  onExtraAction,
}: NotificationsSettingsItemProps) => {
  return (
    <div className={classes.container}>
      <Switch
        checked={checked}
        onChange={(_, checkedValue) => onChange?.(checkedValue)}
        disabled={switchDisabled}
      />
      <TitleWithDescription title={title} description={description} />
      {extraActionTitle && onExtraAction && (
        <Button
          className={classes.actionButton}
          variant="outlined"
          size="small"
          onClick={onExtraAction}
          startIcon={<PlayArrowRoundedIcon fontSize="small" />}
        >
          {extraActionTitle}
        </Button>
      )}
    </div>
  );
};

export { NotificationsSettingsItem };
